import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import { AmazonDisconnectedContent } from './amazon-disconnected-content';
import { DeleteModal } from './delete-amazon-connection-modal';
import ModalPortal from '../../../../components/modal-portal';
import { emptyObject } from 'ui-components/default-props/empty';
import { useModal } from '../../../../hooks/use-modal';
import { LogService } from '../../../../services/log-service';
import { getOauthIntegrations, revokeOauthIntegration } from '../../api/integrations-api';
import { SettingsPageTitle } from '../../components/settings-page-title/settings-page-title';
import { SANTOS_APP_ID } from '../constants';
import messages from '../messages';
import style from '../style.module.less';

export const AmazonPage = () => {
  const [amazonConnection, setAmazonConnection] = useAsyncSafeState(emptyObject);
  const { close, isOpen, open } = useModal();

  useEffect(() => {
    getOauthIntegrations(SANTOS_APP_ID)
      .then((response) => {
        const connectionObject = response?.data.find((intg) => intg.oauthIntegrationId === SANTOS_APP_ID) ?? emptyObject;
        setAmazonConnection(connectionObject);
      })
      .catch((e) => {
        LogService.logError(e);
      });
  }, [setAmazonConnection]);

  const onDeleteAmazonConnection = useCallback(
    async (id) => {
      try {
        await revokeOauthIntegration(id);
        setAmazonConnection(emptyObject);
        close();
      } catch (e) {
        LogService.logError(e);
        NotificationService.showNotification({
          title: '',
          notificationType: NOTIFICATION_TYPE_ERROR,
          content: <FormattedMessage {...messages.failedToDeleteSantosTestConnection} />,
          duration: 3000,
        });
      }
    },
    [close, setAmazonConnection],
  );

  const isAmazonConnectionPresent = !!Object.keys(amazonConnection).length;
  return (
    <>
      <div className={style['settings-section']}>
        <SettingsPageTitle value={messages.santosTestName} />
        <div className={style['amazon-description']}>
          {isAmazonConnectionPresent ? (
            <FormattedMessage {...messages.santosTestConnectedDescription} />
          ) : (
            <FormattedMessage {...messages.santosTestDisconnectedDescription} />
          )}
        </div>
        {isAmazonConnectionPresent ? (
          <Button onClick={open} theme={THEME_CONSTANTS.tertiary}>
            <FormattedMessage {...messages.disconnectFromSantosTest} />
          </Button>
        ) : (
          <AmazonDisconnectedContent />
        )}
      </div>
      {isOpen ? (
        <ModalPortal onClose={close}>
          <DeleteModal id={amazonConnection.oauthIntegrationId} onDeleteAmazonConnection={onDeleteAmazonConnection} />
        </ModalPortal>
      ) : null}
    </>
  );
};
